var exports = {
  "$T": "BookmarkNote.module__bookmarkNote___TW50Um",
  "gA": "BookmarkNote.module__noteText___TW50Um",
  "r2": "BookmarkNote.module__noteAction___TW50Um",
  "EN": "BookmarkNote.module__editor___TW50Um",
  "PC": "BookmarkNote.module__textarea___TW50Um",
  "T6": "BookmarkNote.module__editorActions___TW50Um",
};

module.exports = exports;
